import { Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

const COOKIE_LANGUAGE_KEY = 'lang';

/**
 * When translation change -> we set also new locale to angular (see app: provide: LOCALE_ID).
 * - language is set when user change language (see main-nav.component)
 * - language s set when application start (see app-initializer.factory)
 *
 * !!! Angular LOCALE_ID cannot be change dynamical -> need to app reload.
 * Therefore when using for example angular 'decimal pipe' (pure pipe) we need to provide current locale.
 * 1) in component inject AngularLocalService
 * 2) in template provide locale: `{{value | number: null: angularLocaleService.locale}}`
 */
@Injectable({ providedIn: 'root' })
export class AngularLocaleService {
  public defaultLang = this.cookieService.get(COOKIE_LANGUAGE_KEY) ?? 'en';

  public locale: string = this.defaultLang;
  public thousandSeparator = ' ';
  public decimalMarker: '.' | ',' = ',';

  constructor(private cookieService: CookieService) {}

  public setLocale(newLocale: string) {
    if (!newLocale) {
      return;
    }
    switch (newLocale) {
      case 'sk': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'cs': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'de': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'gb': {
        this.locale = 'en-GB';
        this.thousandSeparator = ' ';
        this.decimalMarker = '.';
        break;
      }
      case 'en': {
        this.locale = 'en';
        this.thousandSeparator = ' ';
        this.decimalMarker = '.';
        break;
      }
      case 'es': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'sl': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'pl': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'ar': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'pt': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      case 'hu': {
        this.locale = newLocale;
        this.thousandSeparator = ' ';
        this.decimalMarker = ',';
        break;
      }
      default: {
        this.locale = this.defaultLang;
        this.thousandSeparator = ' ';
        this.decimalMarker = '.';
        break;
      }
    }
  }
}
